<template>
  <button
    type="button"
    :data-testid="testId"
    :title="TITLE"
    :aria-label="TITLE"
    :aria-pressed="isActive"
    :class="containerClass"
    @click="emit('click')"
  >
    <SVGIcon :path="mdiMapMarkerRadiusOutline" :class="iconClass" />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiMapMarkerRadiusOutline } from '@mdi/js'

import SVGIcon from '@/components/SVGIcon.vue'

const TITLE = 'Tentativas de check'

const props = withDefaults(
  defineProps<{
    /** Base do `data-testid` — o consumidor decide (desktop vs. mobile). */
    testId: string
    isActive?: boolean
    size?: 'normal' | 'small'
  }>(),
  {
    isActive: false,
    size: 'normal'
  }
)

const emit = defineEmits<{
  (e: 'click'): void
}>()

// Mesma linguagem visual dos botões redondos vizinhos (PadlockButton /
// HistoryButton): círculo branco com borda `primary30`, preenchido quando ativo.
//
// `border-solid` explícito porque a raiz aqui é um `<button>`, e não um `<div>`
// como nos vizinhos: o reset do Vuetify (`button { border-style: none }`, que
// entra depois do `tailwind.css` em `app.ts`) anula o `border-style: solid` do
// preflight. Sem ele, `border-2` define só a largura e a borda não aparece.
const containerClass = computed(() => [
  'flex items-center justify-center rounded-full border-2 border-solid border-primary30 shadow-md transition-colors duration-200 cursor-pointer text-primary30',
  props.size === 'small' ? 'w-9 h-9' : 'w-12 h-12',
  props.isActive ? 'bg-[#D5EDF2]' : 'bg-white hover:bg-[#D5EDF2]'
])

const iconClass = computed(() => (props.size === 'small' ? 'w-5 h-5' : 'w-6 h-6'))
</script>
